export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-graph-pie-44e40d8c9aefbbbf08e6b9ad7ae1b3f3.svg";